document.addEventListener("DOMContentLoaded", function () {
  $(".team-slider-container").slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    dots: false,
    infinite: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
    ],
  });
});
